import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=71fefb68&scoped=true&"
import script from "./Dropdown.vue?vue&type=script&lang=ts&"
export * from "./Dropdown.vue?vue&type=script&lang=ts&"
import style0 from "./Dropdown.vue?vue&type=style&index=0&id=71fefb68&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fefb68",
  null
  
)

export default component.exports